export default "__VITE_ASSET__C4fiRU79__"